import React, { Component } from 'react';
import { Translation } from 'react-i18next';
import { Button, Card, Col, Row, Space, Spin } from 'antd';
import { LoadingOutlined, PlusCircleOutlined } from '@ant-design/icons';

import PlannerResourcesList from '../containers/PlannerResourcesListContainer';
import PlannerResourcesCSVButton from '../containers/PlannerResourcesCSVButtonContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import { pathTo } from '../../../Routes';
import Config from '../../../../../Config';
import QueryString from '../../../../../lib/QueryString';
import Logger from '../../../../../lib/Logger';

class PlannerResourcesScreen extends Component {
  static defaultProps = {
    limit: Config.get('DEFAULT_LIST_LENGTH', 10),
    isLoading: true,
  };

  scrollToTop = () => {
    Logger.log('debug', `PlannerResourcesScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  render() {
    const loadingIcon = (
      <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />
    );
    const page = parseInt(
      this.props.match.params.page ? this.props.match.params.page : 1
    );
    const { order, ...filter } = QueryString.parse(this.props.location.search);

    let newFilter = { is_planner: true, ...filter };

    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('planner_resources_route_list')} />

            <Row>
              <Col span={24}>
                <Card
                  title={
                    <Space size={10}>
                      {t('resources_list_title')}
                      <Button
                        size="small"
                        icon={<PlusCircleOutlined />}
                        onClick={(e) =>
                          this.props.history.push(
                            pathTo('PlannerResourceAddScreen')
                          )
                        }
                      >
                        {t('action_create')}
                      </Button>
                      <PlannerResourcesCSVButton
                        order={order}
                        filter={newFilter}
                      />
                    </Space>
                  }
                  extra={this.props.isLoading ? loadingIcon : null}
                >
                  <PlannerResourcesList
                    key={page}
                    component="PlannerResourcesScreen"
                    page={page}
                    limit={this.props.limit}
                    order={order || 'updated_at.desc'}
                    filter={newFilter}
                  />
                </Card>
              </Col>
            </Row>
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerResourcesScreen;

Logger.log('silly', `PlannerResourcesScreen loaded.`);
